import {useState, useEffect} from 'react';

const getWindowDimensions = () => {
    let windowSizes = {
        isMobile: false,
        isTablet: false,
        isDesktop: false
    }
    const {innerWidth: width} = window;
    if (width > 900) {
        windowSizes.isDesktop = true
    } else if (width > 600) {
        windowSizes.isTablet = true
    } else {
        windowSizes.isMobile = true
    }
    return windowSizes
}

const useWindowDimensions = () => {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}

export default useWindowDimensions